import { useCallback } from "react";
import { EnumMenu } from "../../../model";
import { ModulosMock } from "../../mocks/menu-mock";
import { KdsStorageKeys, useKdsStorage } from "../../../services/app";
import { EnumModulo } from "../../../model/enums/enum-modulo";

export const useGetMenu = () => {

  const { getRegistro } = useKdsStorage()
  // const { usuario, getPerfil, getEmpresaSelecionada } = useSessaoAtual()

  // const validaModuloNasPermissoes = useCallback(
  //   (perfil: PerfilModel, modulo: MenuModel): boolean => {
  //     if (modulo?.permissoes?.length === 0) return true;
  //     if (!perfil?.permissoes) return true;

  //     let perms = new Array<PerfilPermissaoModel>();

  //     //CRIO UM OBJ APENAS COM OS ARRAYS
  //     perfil.permissoes.forEach((permissao) => {
  //       perms = perms.concat(permissao);
  //     });

  //     return true
  //     // return validaModuloNosGrupos
  //   }, []);

  const getMenu = useCallback((isMovAberta: boolean, modulos?: EnumMenu[]) => {

    const tipo = getRegistro(KdsStorageKeys.SelecaoModulo, false);
    // const emp = getEmpresaSelecionada();
    // let perfilId = emp?.Perfil.Id;
    // if (isEmpty(emp)) {
    //   perfilId = usuario?.empresa[0].Perfil.Id;
    // }

    // const perfilAtual: PerfilModel = getPerfil().filter((x) => x.id === perfilId)[0];
    let modulos_filtered = ModulosMock
      //FILTRO MODULOS QUE PEDIRAM PARA ESCONDER
      .filter(x => !modulos?.includes(x.codigoPai))
      //FILTRO MODULOS SEM PERMISSAO
      // .filter(x => { return validaModuloNasPermissoes(perfilAtual, x) })
      .filter(x => {
        const menusPorModulo: Record<any, EnumMenu[]> = {
          [EnumModulo.KDS]: [
            EnumMenu.MONITORAMENTO,
            EnumMenu.CONFIGURARSETORES,
            EnumMenu.CONCLUIDOSCANCELADOS,
            EnumMenu.CONFIGURARGERAIS,
            EnumMenu.PESQUISAAVANCADA
          ],
          [EnumModulo.EntregaLocal]: [EnumMenu.ENTREGALOCAL],
          [EnumModulo.EntregaDelivery]: [EnumMenu.ENTREGADELIVERY],
          [EnumModulo.Motoboy]: [EnumMenu.MOTOBOY],
        };

        const permitidos = menusPorModulo[tipo?.modulo];
        return permitidos?.includes(x.codigo) ?? false;
      })


      .sort((firstEl, secondEl) => firstEl.posicao - secondEl.posicao);

    //TIRO OS PAIS SEM FILHOS


    return modulos_filtered;
  }, [getRegistro]);

  return { getMenu };
};
